var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import Box from '@mui/material/Box';
import p24LogoUrl from '@repo/assets/images/przelewy-24-logo.svg?url';
import { colorPalette } from '@repo/mui-config/color-palette';
export function ModalHeader(_a) {
    var closeButton = _a.closeButton, _b = _a.centeredLogo, centeredLogo = _b === void 0 ? true : _b, sx = _a.sx;
    return (_jsxs(Box, { sx: __assign({ display: 'flex', justifyContent: centeredLogo ? 'center' : 'flex-start', alignItems: 'center', position: 'relative' }, sx), children: [_jsx(Box, { component: "img", src: p24LogoUrl, alt: "p24 logo", height: 50 }), closeButton ? (_jsx(IconButton, { "data-testid": "button-close-modal", onClick: closeButton.onClick, sx: {
                    color: colorPalette.black,
                    p: 0,
                    position: 'absolute',
                    right: 0,
                    top: '50%',
                    transform: 'translateY(-50%)',
                }, children: _jsx(Box, { component: "span", sx: {
                        p: '6px',
                        borderRadius: '50%',
                        display: 'flex',
                        justifySelf: 'center',
                        color: colorPalette.black,
                        backgroundColor: colorPalette.cloud.light,
                    }, children: _jsx(CloseIcon, { fontSize: "small" }) }) })) : null] }));
}
